import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Home, LayoutGrid, Dice5, ShoppingBag, User, Newspaper } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useCart } from "@/context/CartContext";

export const MobileBottomNav = () => {
  const { user } = useAuth();
  const { count } = useCart();
  const { pathname } = useLocation();

  const items = [
    { to: "/", label: "Home", icon: Home, id: "home" },
    { to: "/catalog", label: "Catalogo", icon: LayoutGrid, id: "catalog" },
    user
      ? { to: "/wheel", label: "Ruota", icon: Dice5, id: "wheel", gold: true }
      : { to: "/flyer", label: "Volantino", icon: Newspaper, id: "flyer", gold: true },
    { to: "/cart", label: "Carrello", icon: ShoppingBag, id: "cart", badge: count },
    user
      ? { to: "/profile", label: "Profilo", icon: User, id: "profile" }
      : { to: "/login", label: "Accedi", icon: User, id: "login" },
  ];

  return (
    <nav
      className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-[#0A0A0A]/95 backdrop-blur-xl border-t border-white/10 pb-[env(safe-area-inset-bottom)]"
      data-testid="mobile-bottom-nav"
    >
      <div className="grid grid-cols-5 h-16">
        {items.map(({ to, label, icon: Icon, id, badge, gold }) => {
          const active = to === "/" ? pathname === "/" : pathname.startsWith(to);
          return (
            <Link
              key={id}
              to={to}
              className={`relative flex flex-col items-center justify-center gap-1 transition-colors ${active ? "text-[#D4AF37]" : gold ? "text-[#D4AF37]/70" : "text-neutral-400"}`}
              data-testid={`bottom-nav-${id}`}
            >
              <span className={`absolute top-0 h-0.5 w-8 bg-[#D4AF37] transition-opacity ${active ? "opacity-100" : "opacity-0"}`} />
              <span className="relative">
                <Icon className="w-5 h-5" strokeWidth={active ? 2.5 : 2} />
                {badge > 0 && (
                  <span className="absolute -top-1.5 -right-2.5 min-w-[18px] h-[18px] px-1 rounded-full bg-[#D4AF37] text-black text-[10px] font-bold flex items-center justify-center" data-testid="bottom-nav-cart-count">
                    {badge > 9 ? "9+" : badge}
                  </span>
                )}
              </span>
              <span className="font-overline text-[9px] leading-none">{label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};
